import moment from 'moment';
import { Callout } from '../../../../../components/Callout';
import { CustomFormattedMessage } from '../../../../../i18n/i18n';
import { useLocale } from '../../../../../i18n/locale';

type CostAnalyticsCalloutProps = {
  onClick: () => void;
  onClose: () => void;
};

export const CostAnalyticsCallout = ({
  onClose,
  onClick,
}: CostAnalyticsCalloutProps) => {
  const { locale } = useLocale();
  const date = moment().subtract(1, 'month').locale(locale);

  return (
    <Callout
      data-testid="your-insights-cost-analytics"
      type="primary"
      title={
        <CustomFormattedMessage id="overview.yourSimplePay.costAnalytics.title" />
      }
      description={
        <CustomFormattedMessage
          id="overview.yourSimplePay.costAnalytics.description"
          values={{
            month: date.format('MMMM'),
          }}
        />
      }
      onClick={onClick}
      onClose={onClose}
    />
  );
};
